import {showMessage, showMessageForm} from "./modals";

document.querySelectorAll('.js-open-message-form').forEach((el) => {
    el.addEventListener('click', (e) => {
        e.preventDefault();
        showMessageForm(el.dataset.route, 'comment');
    })
});

document.querySelectorAll('.js-send-message').forEach((el) => {
    el.addEventListener('click', (e) => {
        e.preventDefault();

        $.ajax({
            type: 'post',
            url: el.dataset.route,
            data: {
                message: $(el).closest('.modal-content').find('textarea').val(),
                '_token': $('meta[name="csrf-token"]').attr('content'),
            },
            success:function(data){
                $('#modalForm').modal('hide');
                showMessage(data, true, false, 'success');
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    $.each(xhr.responseJSON.errors, function (i, error) {
                        $(document).find('[name="'+i+'"]').siblings('.error').html(error.join('<br>'));
                    });
                }
            }
        });
    })
});

document.querySelectorAll('.js-send-form').forEach((el) => {
    el.addEventListener('change', (e) => {
        el.closest('form').submit();
    })
});
